<script>
  import * as THREE from "three";
  import { easeQuadInOut } from "d3";
  import { nPointsGeometry } from "../utils/geometries";
  import { getContext } from "svelte";
  import { time } from "../stores/global";
  import viewport from "../stores/viewport.js";
  import vertexShader from "../shaders/moon-vertex.glsl";
  import fragmentShader from "../shaders/moon-fragment.glsl";

  export let percentage;
  export let planet;

  const { FOV, FAR, PIXEL_RATIO } = getContext("Start");
  let rafId;

  const tweenValue = function (unif, targetVal, speed) {
    window.cancelAnimationFrame(rafId);
    let time = 0;
    const initialVal = material.uniforms[unif].value;
    const incrementTweenVar = () => {
      if (time + speed < 1) {
        const progress = easeQuadInOut(time);
        material.uniforms[unif].value = Math.round(
          targetVal * progress + initialVal * (1 - progress)
        );
        // console.log(material.uniforms[unif].value);
        rafId = window.requestAnimationFrame(incrementTweenVar);
        time += speed;
      } else {
        material.uniforms[unif].value = targetVal;
      }
    };
    rafId = window.requestAnimationFrame(incrementTweenVar);
  };

  const uniforms = {
    uTime: {
      value: $time,
    },
    uResolution: {
      value: {
        x: $viewport.width,
        y: $viewport.height,
      },
    },
    uPixelRatio: {
      value: PIXEL_RATIO,
    },
    uRad: {
      value: 0.3,
    },
    uFov: {
      value: FOV,
    },
    uGlowNum: {
      value: Math.floor(percentage * 100),
    },
    uOpacity: {
      value: 1,
    },
    uDisplay: {
      value: 1,
    },
    uNearOpacity: {
      value: 1,
    },
    uAdjustAspectRatio: {
      value: 0,
    },
    uBaseSize: {
      value: 0.3,
    },
  };

  const material = new THREE.ShaderMaterial({
    transparent: true,
    uniforms: uniforms,
    vertexShader: vertexShader,
    fragmentShader: fragmentShader,
  });

  const geometry = nPointsGeometry(102);
  const points = new THREE.Points(geometry, material);

  planet.add(points);

  $: {
    material.uniforms.uTime.value = $time;
  }

  $: {
    material.uniforms.uResolution.value = {
      x: $viewport.width,
      y: $viewport.height,
    };
  }

  $: {
    tweenValue("uGlowNum", Math.round(percentage * 102), 0.03);
  }
</script>
